import { MultipleModalConfigs } from "features/shared/types/modal";

const TAG_MODAL_CONFIG: MultipleModalConfigs = {
    ADD: {
        headingText: "New Tag",
        submitBtnText: "Add",
    },
    UPDATE: {
        headingText: "Update Tag",
        submitBtnText: "Update",
    },
    VIEW: {
        headingText: "View Tag",
    },
};

export default TAG_MODAL_CONFIG;
